import React, { Component } from 'react'
import BrownianMovement from '../Animations/Movements/BrownianMovement'
import OvertakeOtherEntity from '../Animations/Movements/OvertakeOtherEntity'
import { ScorerSpeed, WalkSpeed, BrownianSpeed } from '../Animations/Scenes/Constants'
import PlayerMoveToWithSpeed  from '../Animations/Movements/PlayerMoveToWithSpeed'

class PitchEntity extends Component {

  static propTypes = {
      currentEvent: React.PropTypes.number.isRequired,
      gameSpeed: React.PropTypes.number.isRequired,
      pitchHeight: React.PropTypes.number.isRequired,
      pitchIdent: React.PropTypes.number.isRequired
  }

    constructor(props) {
        super(props);
        this.opacity = 1;
        this.CurrentPosition =  {Top:0, Left: 0};
        this.currentAnimationCancelationToken = {};
    }

    componentDidUpdate(prevProps, prevState){
      if(this.props.currentEvent != prevProps.currentEvent) {
        if(Math.abs(this.props.currentEvent - prevProps.currentEvent) > 1) {
          let {position, time, owner} = this.readEvent(this.props.currentEvent, true);
          time = 30;
          this.moveToNewPosition(position, time, owner, true);
        }
        else {
          let {position, time, owner} = this.readEvent(this.props.currentEvent);
          this.moveToNewPosition(position, time, owner);
        }
      }
    }

    moveToNewPosition(position, time, owner, hideModel = false) {
        this.cancelPreviousAnimation();
        this.setOpacity(1);
        this.playMovementAnimation(position, time, owner, hideModel);
    }

    setOpacity(opacity) {
      this.opacity = opacity;
    }

    cancelPreviousAnimation() {
      if(this.CurrentAnimation != null){
        this.CurrentAnimation.Cancell();
      }

      if(this.currentAnimationCancelationToken != null && this.currentAnimationCancelationToken.cancel != null)
        this.currentAnimationCancelationToken.cancel();

      this.currentAnimationCancelationToken = {};
    }

    readEvent(eventNum){
      return {position: this.CurrentPosition, time: 1000};
    }

    BrownianMovement(gameSpeed, duration){
        this.cancelPreviousAnimation();
        this.CurrentAnimation = new BrownianMovement(this, duration);
        return this.CurrentAnimation.Play(this.props.gameSpeed).catch(this.processCancellation);
    }

    MoveToWithSpeed(gameSpeed, playerSpeed, position, options = {useBrownian: false, brownianTicksDuration: null}) {
        this.cancelPreviousAnimation();
        this.CurrentAnimation = new PlayerMoveToWithSpeed(this, playerSpeed, position);
        if(options.useBrownian == null || options.useBrownian == false)
          return this.CurrentAnimation.Play(this.props.gameSpeed).catch(this.processCancellation);
        else
          return this.CurrentAnimation.Play(this.props.gameSpeed).then(() => this.BrownianMovement(this.props.gameSpeed, null));
    }


    OvertakeOtherPlayer(otherPlayer, gameSpeed, playerSpeed) {
        this.cancelPreviousAnimation();
        this.CurrentAnimation = new OvertakeOtherEntity(this, otherPlayer, playerSpeed, 20);
        return this.CurrentAnimation.Play(this.props.gameSpeed).catch(this.processCancellation);
    }

    processCancellation(err) {
      if(err != 'cancelled')
          throw err;
    } 

    CheckIfOutsidePitch() {
      if(this.CurrentPosition.Top < -this.props.pitchIdent + 8 || this.CurrentPosition.Top > this.props.pitchHeight + this.props.pitchIdent - 8)
        return true;

      return false;
    }

    InjuredWithoutSubstitution() {
      if(this.props.player.Injured && this.props.player.BenchSlot == null)
        return true;

      return false;
    }

    getContainerClass() {
      switch(this.props.size)
      {
        case 0:
          return "player_container medium_size";
          break;
        case 1:
          return "player_container medium_size";
          break;
        case 2:
          return "player_container large_size";
          break;
      }
    }

    getPositionDiff(){
      switch(this.props.size)
      {
        case 0:
          return 5;
          break;
        case 1:
          return 5;
          break;
        case 2:
          return 8;
          break;
      }
    }
}

export default PitchEntity



/** WEBPACK FOOTER **
 ** ./src/components/Pitch/PitchEntity.js
 **/